import React from "react";
import centerpoin from "./centerpoin.json";
import "./centerpoin.scss";
import Cardrumah from "../../../component/cardrumah/cardrumah.jsx";
import vpp from "../../../asset/centerpoin/vpp/vpp.js";
import victoria from "../../../asset/centerpoin/victoria/victoria.js";
import permatahijau from "../../../asset/centerpoin/permatahijau/permatahijau.js";
const imageMap = {
  vpp,
  victoria,
  permatahijau,

  // Add other image arrays here if you have more sets
};

const Centerpoin = () => {
  return (
    <div className="centerpoin">
      <div className="container-centerpoin">
        <div className="header">
          <div className="judul-centerpoin">
            <div className="pink"></div>
            <span>Center Point</span>
          </div>
        </div>
        <div className="cardhome-container">
          {centerpoin.cards.map((card, index) => {
            // Determine the logo dynamically
            return (
              <Cardrumah
                key={index}
                carousel={imageMap[card.imagesKey]}
                title={card.title}
                subtitle={card.subtitle}
                price={card.price}
                subprice={card.subprice}
                details={card.details}
                whatsappLink={card.whatsappLink} // Pass the WhatsApp link
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Centerpoin;
